import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Brightness4Icon from '@material-ui/icons/Brightness4'; // moon  -> shown in light mode
import Brightness7Icon from '@material-ui/icons/Brightness7'; // sun   -> shown in dark mode
import { useColorMode } from '../../context/colorMode/colorMode.context';

/**
 * Dark/light mode switch backed by ColorModeContext.
 *
 * @param {'menuItem' | 'iconButton'} [props.variant]  Render style. Default
 *   "menuItem" drops straight into the profile MenuList; "iconButton" is a
 *   standalone toggle (e.g. for an app bar).
 * @param {(e) => void} [props.onToggle]  Optional extra handler (e.g. to close a menu).
 */
const DarkModeToggle = ({ variant = 'menuItem', onToggle, ...rest }) => {
    const { isDark, toggleColorMode } = useColorMode();

    const handleClick = (e) => {
        toggleColorMode();
        if (onToggle) onToggle(e);
    };

    if (variant === 'iconButton') {
        return (
            <IconButton
                aria-label="Toggle dark mode"
                title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
                onClick={handleClick}
                {...rest}
            >
                {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        );
    }

    return (
        <MenuItem
            onClick={handleClick}
            style={{ color: 'var(--brand-primary, #FF6900)', fontSize: 14 }}
            {...rest}
        >
            <ListItemIcon style={{ minWidth: 32, color: 'inherit' }}>
                {isDark ? <Brightness7Icon fontSize="small" /> : <Brightness4Icon fontSize="small" />}
            </ListItemIcon>
            {isDark ? 'Light Mode' : 'Dark Mode'}
        </MenuItem>
    );
};

export default DarkModeToggle;
